import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { sortCollectionsByCategory } from '../../helpers/sortCollections';
import { Collection, CollectionsResponse } from '../../types';

interface State {
  collections: Collection[];
  isLoading: boolean;
}

export const initialState: State = {
  collections: [],
  isLoading: false,
};

const collectionsSlice = createSlice({
  name: 'collections',
  initialState,
  reducers: {
    setCollections(state, { payload }: PayloadAction<CollectionsResponse>) {
      state.collections = sortCollectionsByCategory(
        payload.categories,
        payload.campaigns,
      );
    },
    setIsLoading(state, { payload }: PayloadAction<boolean>) {
      state.isLoading = payload;
    },
  },
});

export const { setCollections, setIsLoading } = collectionsSlice.actions;

export default collectionsSlice.reducer;
